/**
 * Agregat tlumaczen. Kazdy obszar aplikacji ma wlasny plik JSON, zeby przy
 * ~1000 kluczach dalo sie jeszcze cokolwiek znalezc i zeby konflikty w gicie
 * byly lokalne.
 *
 * Parytet kluczy PL/EN pilnuje `npm run i18n:check` (scripts/check-locales.js).
 */
import enAccount from './en/account.json'
import enApp from './en/app.json'
import enAuth from './en/auth.json'
import enBuilder from './en/builder.json'
import enCommon from './en/common.json'
import enComponents from './en/components.json'
import enCreateApp from './en/createApp.json'
import enDevice from './en/device.json'
import enErrors from './en/errors.json'
import enMedia from './en/media.json'
import enMessages from './en/messages.json'
import enNav from './en/nav.json'
import enRegion from './en/region.json'
import enRoles from './en/roles.json'
import enScheduler from './en/scheduler.json'
import enUsers from './en/users.json'
import enValidation from './en/validation.json'
import enWorkspace from './en/workspace.json'

import plAccount from './pl/account.json'
import plApp from './pl/app.json'
import plAuth from './pl/auth.json'
import plBuilder from './pl/builder.json'
import plCommon from './pl/common.json'
import plComponents from './pl/components.json'
import plCreateApp from './pl/createApp.json'
import plDevice from './pl/device.json'
import plErrors from './pl/errors.json'
import plMedia from './pl/media.json'
import plMessages from './pl/messages.json'
import plNav from './pl/nav.json'
import plRegion from './pl/region.json'
import plRoles from './pl/roles.json'
import plScheduler from './pl/scheduler.json'
import plUsers from './pl/users.json'
import plValidation from './pl/validation.json'
import plWorkspace from './pl/workspace.json'

import skAccount from './sk/account.json'
import skApp from './sk/app.json'
import skAuth from './sk/auth.json'
import skBuilder from './sk/builder.json'
import skCommon from './sk/common.json'
import skComponents from './sk/components.json'
import skCreateApp from './sk/createApp.json'
import skDevice from './sk/device.json'
import skErrors from './sk/errors.json'
import skMedia from './sk/media.json'
import skMessages from './sk/messages.json'
import skNav from './sk/nav.json'
import skRegion from './sk/region.json'
import skRoles from './sk/roles.json'
import skScheduler from './sk/scheduler.json'
import skUsers from './sk/users.json'
import skValidation from './sk/validation.json'
import skWorkspace from './sk/workspace.json'

export default {
  en: {
    account: enAccount,
    app: enApp,
    auth: enAuth,
    builder: enBuilder,
    common: enCommon,
    components: enComponents,
    createApp: enCreateApp,
    device: enDevice,
    errors: enErrors,
    media: enMedia,
    messages: enMessages,
    nav: enNav,
    region: enRegion,
    roles: enRoles,
    scheduler: enScheduler,
    users: enUsers,
    validation: enValidation,
    workspace: enWorkspace
  },
  pl: {
    account: plAccount,
    app: plApp,
    auth: plAuth,
    builder: plBuilder,
    common: plCommon,
    components: plComponents,
    createApp: plCreateApp,
    device: plDevice,
    errors: plErrors,
    media: plMedia,
    messages: plMessages,
    nav: plNav,
    region: plRegion,
    roles: plRoles,
    scheduler: plScheduler,
    users: plUsers,
    validation: plValidation,
    workspace: plWorkspace
  },
  sk: {
    account: skAccount,
    app: skApp,
    auth: skAuth,
    builder: skBuilder,
    common: skCommon,
    components: skComponents,
    createApp: skCreateApp,
    device: skDevice,
    errors: skErrors,
    media: skMedia,
    messages: skMessages,
    nav: skNav,
    region: skRegion,
    roles: skRoles,
    scheduler: skScheduler,
    users: skUsers,
    validation: skValidation,
    workspace: skWorkspace
  }
}
